import React, { useEffect, useState } from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import BgUser from '../../img/bg.jpg'
import './User.css'
import { RootState, useAppDispatch, useAppSelector } from '../../store'
import { OrderItem } from './components'
import { Order } from '../../redux/reducers/orderReducers'
import { formatUSD } from '../../utils/formatter'
import { getOrdersUserAPI } from '../../redux/actions/orderActions'

const User = () => {
  const dispatch = useAppDispatch()
  const [showDetails, setShowDetails] = useState(false)
  const [details, setDetails] = useState<Order>()
  const user = useAppSelector((state: RootState) => state.user)
  const { orders } = useAppSelector((state: RootState) => state.orders)

  const getOrderDetail = (orderID: string) => {
    const order = orders.find(order => order._id === orderID)
    setDetails(order)
  }

  useEffect(() => {
    dispatch(getOrdersUserAPI())
  }, [])

  const multiCheck = (id: string) => {
    setShowDetails(!showDetails)
    getOrderDetail(id)
  }
  const total = () => {
    const total =
      details?.items.reduce((cur, item) => {
        cur += (item?.product?.price || 0) * (item?.quantity || 1)
        return cur
      }, 12.99) || 0

    return total
  }

  if (!user.user) return null

  return (
    <div className="main">
      <Header />
      <div className="user-wrapper">
        <div className="user">
          <div className="user__infor">
            <div className="user__infor--bx">
              <div className="__infor picture">
                <img src={BgUser} alt="user" />
              </div>
              <p className="title-infor">Information user</p>
              <div className="__infor fm__input name">
                <span> Name: </span>
                {user.user.username}
              </div>
              <div className="__infor fm__input phone">
                <span> Phone: </span>
                {user.user.phone}
              </div>
              <div className="__infor fm__input email">
                <span> Email: </span>
                {user.user.email}
              </div>
              <div className="__infor fm__input address">
                <span> Address: </span>
                {user.user.address}
              </div>
              <div className="__infor fm__input company">
                <span> Company: </span>
                {user.user.company}
              </div>
              <div className="__infor fm__input region">
                <span> Region: </span>
                Viet Nam
              </div>
              <div className="__infor">
                <button className="user--edit-infor">Edit</button>
              </div>
            </div>
          </div>
          <div className="user__orders">
            <table className="__orders">
              <thead>
                <tr className="__orders--header">
                  <th>Orders</th>
                </tr>
              </thead>
              <tbody>
                {(orders || []).map(order => {
                  return (
                    <tr
                      className="__orders--view"
                      key={order?._id + '' + Math.random()}
                    >
                      <td>Order: #{(order?._id || '').substring(17, 23)}</td>
                      <td className="od--flex-bw">
                        <div className="__order--txt">Total:</div>
                        <div className="__order--result">
                          {formatUSD(order.total_order)}
                        </div>
                      </td>
                      <td className="od--flex-bw">
                        <div className="__order--txt">Status:</div>
                        <div
                          className="__order--status"
                          style={{
                            color:
                              details && details.status === 'new'
                                ? '#e84118'
                                : '#009432',
                            textTransform: 'capitalize',
                            fontWeight: '600'
                          }}
                        >
                          {order.status}
                        </div>
                      </td>
                      <td>
                        <button
                          className="vw-detail-order"
                          onClick={() => multiCheck(order._id)}
                        >
                          Details
                        </button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div
          className={showDetails ? 'order-details overlay' : 'order-details'}
          onClick={() => setShowDetails(!showDetails)}
        >
          <div className={showDetails ? 'details active' : 'details'}>
            <h1 className="order--id">
              Order #{details ? details._id.substring(17, 23) : ''}
            </h1>
            <div className="order-date">
              <p className="order-status">
                Status:
                <span
                  className="__status"
                  style={{
                    color:
                      details && details.status === 'New'
                        ? '#e84118'
                        : '#009432',
                    textTransform: 'capitalize',
                    fontWeight: '600'
                  }}
                >
                  {details ? details.status : ''}
                </span>
              </p>
              <p className="order-status">
                Created At :{' '}
                {details
                  ? `${details.createdAt.substring(0, 10)} at
                    ${details.createdAt.substring(11, 16)}`
                  : ''}
              </p>
            </div>
            <div className="products--list">
              <h1 className="order--header">Product Listing</h1>
              {(details?.items || []).map(item => (
                <OrderItem key={item?._id + '' + Math.random()} item={item} />
              ))}
            </div>
            <div className="order-total">
              <div className="l-f-order">
                <p>
                  Subtotal: <span>{formatUSD(total() - 12.99)}</span>
                </p>
                <p>
                  Shipping: <span>12.99$</span>
                </p>
              </div>
              <div className="r-f-order">
                <p>Total:</p>
                <h1>{formatUSD(total())}</h1>
              </div>
            </div>
            <div className="sh-address">
              Ship to:
              <br /> {details ? details.address : ''}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default User
